const base = require("./base");
module.exports = {
  ...base.apiFactory(),
  /**
   * Whop App View 引导页「去授权」按钮的落点域名 —— 2026-09-22。
   *
   * 必须写绝对地址、且分环境取值: Whop 的 App 只有【一个】base_url
   * (官方 spec: "The production base URL where the app is hosted", 单值字符串;
   *  对比 redirect_uris 是数组, 所以回调能同时登记 com+cn 两条, base_url 不能),
   * iframe 恒从那一个域名加载 ⇒ 用 ctx.origin 之类的请求上下文推导恒等于它、起不到分环境作用。
   * 与后端 whop_redirectUri / whop_appInstallFallbackUrl 同一套分环境思路。
   */
  _whop_authorize_origin_260922: "https://www.cjdropshipping.com",
};
